import { FC, useEffect, useRef, useState } from "react";
import { Grid, Box, CircularProgress, IconButton } from "@mui/material";

import CartRow from "./cart-row";
import { Colors } from "../../../../configs";
import { CartItem } from "../../../../typings/interfaces/pos/cart-item";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { CartSliceAction } from "../../../../redux/slice/cartSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { getFilteredBillsAction } from "../../../../redux/actions/pintagAction";
import DebugDrawer from "../debug-drawer/debug-drawer";

export interface ICartSectionProps {
  onSelect(index: number): void;
  mode?: "checkin" | "pickup";
}

const CartSection: FC<ICartSectionProps> = ({ onSelect, mode = "checkin" }) => {
  const { selectedSession, selectedCartItem, cartMode, billByIdLoading } =
    useAppSelector((state) => state.cart);
  const dispatch = useAppDispatch();
  const [openDebugDrawer, setOpenDebugDrawer] = useState(false);
  // const { getDryCleanPrice } = usePricing();

  const handleOnCartItemClick = (item: CartItem) => {
    dispatch(CartSliceAction.setSelectedCartItem(item));
  };

  const boxRef = useRef<HTMLDivElement | null>(null);

  const { cartHistorySelectedRows, billById } = useAppSelector(
    (state) => state.cart
  );

  const scrollToBottom = () => {
    if (boxRef.current) {
      boxRef.current.scrollTop = boxRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [selectedSession?.cartItems?.filter((row) => row.finalized).length]);

  const styles = {
    tableHeadingCell: {
      borderRadius: "0.85rem",
      background: Colors.SECONDARY,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      padding: "0.5rem 0.71rem",
      boxSizing: "border-box",
      color: "white",
      fontSize: "1.142857142857143rem",
      whiteSpace: "nowrap",
    },
  };

  const finalizedItemsCount = selectedSession?.cartItems?.filter((item) => item.finalized).length || 0;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        background: Colors.WHITE,
        borderRadius: "1.25rem",
        paddingY: "0.71rem",
        paddingLeft: "0.71rem",
        paddingRight: "0.45rem",
        gap: "1.14rem",
        overflow: "hidden",
        boxShadow: "0 0.2rem 0.85rem rgba(0,0,0,0.07)",
        border: "1px solid #EFEFEF",
        height:
          cartMode !== "pickup"
            ? "28.42rem"
            : selectedSession?.cartItems[0]?.note == null ||
              selectedSession?.cartItems == null
            ? "33.7rem"
            : "26.3rem",
        position: "relative",
      }}
    >
      {/* Debug button */}
      {/* {finalizedItemsCount > 0 && (
        <IconButton
          onClick={() => setOpenDebugDrawer(true)}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            bgcolor: Colors.SECONDARY,
            color: "white",
            zIndex: 10,
            "&:hover": { bgcolor: Colors.SECONDARY },
            width: "2.5rem",
            height: "2.5rem",
          }}
          size="small"
        >
          🔍
        </IconButton>
      )} */}
      <Box>
        <Grid container sx={{ gap: "1.21428571rem", height: "100%" }}>
          <Grid item xs={12}>
            <Box style={{ position: "sticky", top: 0 }}>
              <Grid
                container
                sx={{
                  gap: "0.35rem",
                  flexWrap: "nowrap",
                }}
              >
                <Grid item xs={1.01} sx={styles.tableHeadingCell}>
                  Qty
                </Grid>
                <Grid item xs={6.5} sx={styles.tableHeadingCell}>
                  Description
                </Grid>
                <Grid item xs={1.64} sx={styles.tableHeadingCell}>
                  Status
                </Grid>
                <Grid item xs={1.27} sx={styles.tableHeadingCell}>
                  Unit Price
                </Grid>
                <Grid item xs={1.27} sx={styles.tableHeadingCell}>
                  Total
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ height: "22.9rem" }}>
            <Box
              ref={boxRef}
              sx={{
                height:
                  cartMode !== "pickup" && selectedCartItem === null
                    ? "23.5rem"
                    : selectedSession?.cartItems[0]?.note == null ||
                      selectedSession?.cartItems == null
                    ? "23.5rem"
                    : "21rem",
                overflowY: "auto",
                marginRight: " -0.125rem",
                "&::-webkit-scrollbar": {
                  position: "absolute",
                  width: "0.15rem",
                  right: "8rem",
                  paddingRight: "-0.8rem",
                  marginRight: "-2rem",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#ADADAD",
                  borderRadius: "0rem",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                  borderRadius: "0rem",
                },
                // make scrolling animation smooth
                scrollBehavior: "smooth",
              }}
            >
              {selectedSession?.cartItems
                // ?.filter((item) => item.finalized)
                ?.map((cartItem, i) => {
                  return (
                    <CartRow
                      key={i}
                      onSelect={() => handleOnCartItemClick(cartItem)}
                      cartItem={cartItem}
                      mode={mode}
                      // data={
                      // {
                      // qty: cartItem.qty,
                      // serviceType: cartItem?.serviceType?.categoryName || "",
                      // textureType: cartItem.texture || "",
                      // color: cartItem.garmentColor || [],
                      // materialType: cartItem.materialType?.name || "",
                      // clothSubType: cartItem?.garmentType?.name || "",
                      // clothType: cartItem?.garmentStyle?.name || "",
                      // instructions: cartItem.instructions,
                      // damages: cartItem.damages,
                      // upcharges: cartItem.upcharges || [],
                      // status: "In Progress",
                      // unitPrice: cartItem.unitPrice,
                      // note: cartItem.note,
                      // }
                      // }
                      status="In Progress"
                      firstRow={i === 0}
                      lastRow={i === selectedSession.cartItems?.length - 1}
                    />
                  );
                })}
              {selectedSession === null &&
                cartMode === "pickup" &&
                billByIdLoading && (
                  <Box sx={{ width: "100%" }}>
                    <CircularProgress sx={{ mx: "auto", mt: "3rem" }} />
                  </Box>
                )}
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Debug Drawer */}
      <DebugDrawer
        isOpen={openDebugDrawer}
        toggleDrawer={() => setOpenDebugDrawer(!openDebugDrawer)}
      />
    </Box>
  );
};

export default CartSection;
